export default {
  'lineitemdetail': ['inputtype', 'amt', 'amttype', 'inflationdetail', 'areaid'],
  'downtimedetail': ['inputtype', 'mosdowntime'],
  'inflationdetail': ['inputtype', 'amt', 'type', 'compoundtype'],
  'renewalprobabilitydetail': ['inputtype', 'percentrenew'],
  'areadetail': ['inputtype', 'amt'],
  'freerentdetail': ['inputtype', 'mosnew', 'mosrenew', 'amttype', 'freerentrevtype'],
  'increasedetail': ['inputtype', 'amt', 'amttype', 'inflationdetail', 'effectivemonth', 'increasedetail'],
  'payoutdetail': ['inputtype', 'mosoffset'],
  'rentdetail': ['inputtype', 'amtnew', 'amtrenew', 'amttype', 'inflationdetail'],
  'tenantcapitaldetail': ['inputtype', 'amtnew', 'amtrenew', 'amttype', 'inflationdetail', 'payoutdetail', 'type'],
  'overridetype': ['overriderent', 'overrideti', 'overridelc', 'overrideoc', 'overriderenewalprob', 'overridedowntime']
}